import { home, trainDetail, exam, study, coreCourse, coreCourse01 } from '@/pages/services/shansongStudy'
import { courseOffline } from '@/pages/services/recruit'
import { getStorage } from '@/utils/common'
import { openRecruit } from '@/utils/appAgreement'
const back = (error: any) => {
  if (error.data) {
    if (error.data.msg === '无效培训.') {
      // 招募
      if (getStorage('traineeScene') === 102) {
        // 上报后台更改状态
        courseOffline({}).then(() => {
          // 1 招募 2 转城
          openRecruit()
        })
      } else {
        location.href = '/courierView/home'
      }
    }
  }
}
export default {
  namespace: 'shansongStudy',

  state: {
    homeList: {},
    categroyData: [],
    categroyDetail: {},
    trainTestData: {},
    trainTestFinsh: {},
    answerDetail: {},
    errorQuestionList: [],
    courseData: {}
  },

  subscriptions: {
    setup () {
      // eslint-disable-line
    }
  },

  effects: {
    // 学习平台首页数据
    * getHomeData ({ payload: value }, { call, put, select }) {
      // eslint-disable-line
      try {
        const { data } = yield call(home, value)

        const tempList = yield select(
          (state: any) => state.shansongStudy.homeList
        )
        const homeList = { ...tempList, ...data.data }
        // 此处清洗数据
        yield put({ type: 'HOME_LIST', payload: { homeList } })
        return data
      } catch (error) {
        console.log(error)
      }
    },
    // 培训分类列表
    * getCategroyData ({ payload: value }, { call, put, select }) {
      try {
        const { data } = yield call(home, value)
        const tempList = yield select(
          (state: any) => state.shansongStudy.categroyData
        )
        const categroyData = { ...tempList, ...data.data }
        yield put({ type: 'CATEGROY_DATA', payload: { categroyData } })
        return data.data
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 获取培训详情信息
    * getCategroyDetail ({ payload: value }, { call, put, select }) {
      try {
        const { data } = yield call(trainDetail, value)
        const tempList = yield select(
          (state: any) => state.shansongStudy.categroyDetail
        )
        const categroyDetail = { ...tempList, ...data.data }
        yield put({ type: 'TRAIN_DETAIL', payload: { categroyDetail } })
        return categroyDetail
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 获取考试题目
    * getTrainTest ({ payload: value }, { call, put, select }) {
      try {
        const { data } = yield call(exam, value)
        const oldData = yield select(
          (state: any) => state.shansongStudy.trainTestData
        )
        const trainTestData = { ...oldData, ...data.data }
        yield put({ type: 'TRAIN_TEST', payload: { trainTestData } })
        return trainTestData
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 答题结束
    * trainTest ({ payload: value }, { call, put, select }) {
      try {
        const { data } = yield call(exam, value)
        const oldData = yield select(
          (state: any) => state.shansongStudy.trainTestFinsh
        )
        const trainTestFinsh = { ...oldData, ...data.data }
        yield put({ type: 'TRAIN_TEST', payload: { trainTestFinsh } })
        return trainTestFinsh
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 回答问题
    * answerQuestion ({ payload: value }, { call, put, select }) {
      try {
        const { data } = yield call(exam, value)
        const oldData = yield select(
          (state: any) => state.shansongStudy.trainTestFinsh
        )
        const answerDetail = { ...oldData, ...data.data }
        yield put({ type: 'ANSWER_QUESTION', payload: { answerDetail } })
        return answerDetail
      } catch (error) {
        back(error)
      }
    },
    // 错题集
    * getErrorQuestionList ({ payload: value }, { call, put, select }) {
      try {
        const { data } = yield call(exam, value)
        const oldData = yield select(
          (state: any) => state.shansongStudy.errorQuestionList
        )
        const errorQuestionList = [...oldData, ...data.data]
        yield put({ type: 'ANSWER_QUESTION', payload: { errorQuestionList } })
        return errorQuestionList
      } catch (error) {
        back(error)
        console.log(error)
      }
    },
    // 课程学习数据
    * getCourse ({ payload: value }, { call, put, select }) {
      try {
        const data = yield call(study, value)
        const oldData = yield select(
          (state: any) => state.shansongStudy.errorQuestionList
        )
        const courseData = { ...oldData, ...data.data }

        yield put({ type: 'COURSE_DATA', payload: { courseData } })
        return courseData
      } catch (error) {
        console.log(error)
        back(error)
      }
    },
    // 获取课程评价状态接口/提交
    * getCoreCourse ({ payload: value }, { call, put, select }) {
      try {
        const { data } = yield call(coreCourse, value)

        const coreCourseData = { ...data.data }
        return coreCourseData
      } catch (error) {
        back(error)
        console.log(error)
      }
    }
  },

  reducers: {
    HOME_LIST (state: any, { payload: { homeList } }) {
      return { ...state, homeList }
    },
    CATEGROY_DATA (state: any, { payload: { categroyData } }) {
      return { ...state, categroyData }
    },
    TRAIN_DETAIL (state: any, { payload: { categroyDetail } }) {
      return { ...state, categroyDetail }
    },
    TRAIN_TEST (state: any, { payload: { trainTestData } }) {
      return { ...state, trainTestData }
    },
    TRAIN_TEST_FINSH (state: any, { payload: { trainTestFinsh } }) {
      return { ...state, trainTestFinsh }
    },
    ANSWER_QUESTION (state: any, { payload: { answerDetail } }) {
      return { ...state, answerDetail }
    },
    ERROR_QUESTION (state: any, { payload: { errorQuestionList } }) {
      return { ...state, errorQuestionList }
    },
    COURSE_DATA (state: any, { payload: { courseData } }) {
      return { ...state, courseData }
    }
  }
}
